// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeFacultyCard_home-faculty-card__uKhPU {
  display: flex;
  width: 100%;
  padding: 20px;
  align-items: center;
  gap: 16px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--accent-color-light);
  transition: all 0.2s;
}
.HomeFacultyCard_home-faculty-card__uKhPU:hover {
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(-4px);
}
.HomeFacultyCard_home-faculty-card__uKhPU:hover .HomeFacultyCard_home-faculty-card__right--info--title--name__xNwEy {
  text-decoration: underline;
}
.HomeFacultyCard_home-faculty-card__wrapper__lM0N1 {
  width: 100%;
  height: 100%;
}
.HomeFacultyCard_home-faculty-card__left__hyc5A {
  display: flex;
  width: 140px;
  aspect-ratio: 1/1;
  flex-direction: column;
  align-items: flex-start;
  gap: 100px;
  flex-shrink: 0;
  border-radius: 9999px;
  overflow: hidden;
  border: 1px solid var(--light-grey);
}
.HomeFacultyCard_home-faculty-card__left--avatar__v3BDs {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  align-self: stretch;
  object-fit: cover;
}
.HomeFacultyCard_home-faculty-card__right__dnbO2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0;
  align-self: stretch;
  border-left: 1px solid var(--accent-color-medium);
}
.HomeFacultyCard_home-faculty-card__right--info__I8Ybj {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}
.HomeFacultyCard_home-faculty-card__right--info--title__Auifa {
  display: flex;
  padding: 0px 0px 8px 20px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid var(--accent-color-medium, #4a6fa5);
}
.HomeFacultyCard_home-faculty-card__right--info--title--name__xNwEy {
  color: var(--accent-color);
  font-size: 16px;
  font-weight: 700;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.HomeFacultyCard_home-faculty-card__right--info--title--institution__UrBrR {
  color: var(--text-1);
  font-size: 14px;
  font-weight: 700;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.HomeFacultyCard_home-faculty-card__right--info--stat__J0neE {
  display: flex;
  padding: 8px 0px 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
.HomeFacultyCard_home-faculty-card__right--info--stat--position__H\\+Sq6 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis;
  align-self: stretch;
  color: var(--dark-grey);
  font-size: 12px;
}
.HomeFacultyCard_home-faculty-card__right--info--stat--statistics__ZV5XT {
  display: flex;
  align-items: center;
  gap: 20px;
}
.HomeFacultyCard_home-faculty-card__right--info--stat--statistics--item__ZxcUF {
  display: flex;
  gap: 4px;
}
.HomeFacultyCard_home-faculty-card__right--info--stat--statistics--item__ZxcUF svg {
  width: 14px;
  height: 14px;
}
.HomeFacultyCard_home-faculty-card__right--info--stat--statistics--item__ZxcUF svg path {
  stroke: var(--accent-color);
}
.HomeFacultyCard_home-faculty-card__right--info--stat--statistics--item__ZxcUF svg line {
  stroke: var(--accent-color);
}
.HomeFacultyCard_home-faculty-card__right--info--stat--statistics--item__ZxcUF p {
  color: var(--text-1);
  font-size: 12px;
}
.HomeFacultyCard_home-faculty-card__right--info--stat--statistics--item__ZxcUF p span {
  font-weight: 700;
}
.HomeFacultyCard_home-faculty-card__right--keywords__Bfs14 {
  padding-left: 20px;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 32px;
}
.HomeFacultyCard_home-faculty-card__right--keywords__wrapper__bH3Sr {
  position: absolute;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.HomeFacultyCard_home-faculty-card__right--keywords--item__MZOqj {
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--accent-color-medium);
  color: var(--accent-color-light);
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeFaculty/HomeFacultyCard/HomeFacultyCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,oBAAA;AACF;AAAE;EACE,yCAAA;EACA,2BAAA;AAEJ;AAAI;EACE,0BAAA;AAEN;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mCAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AADN;AAKE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,iDAAA;AAHJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAFN;AAGM;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4DAAA;AADR;AAEQ;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,uBAAA;AAAV;AAEQ;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,uBAAA;AAAV;AAIM;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAFR;AAGQ;EACE,oBAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADV;AAGQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADV;AAEU;EACE,aAAA;EACA,QAAA;AAAZ;AAEY;EACE,WAAA;EACA,YAAA;AAAd;AACc;EACE,2BAAA;AAChB;AACc;EACE,2BAAA;AAChB;AAGY;EACE,oBAAA;EACA,eAAA;AADd;AAGc;EACE,gBAAA;AADhB;AASI;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAPN;AASM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAPR;AAUM;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,sCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AARR","sourcesContent":[".home-faculty-card {\n  display: flex;\n  width: 100%;\n  padding: 20px;\n  align-items: center;\n  gap: 16px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--accent-color-light);\n  transition: all 0.2s;\n  &:hover {\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);\n    transform: translateY(-4px);\n\n    .home-faculty-card__right--info--title--name {\n      text-decoration: underline;\n    }\n  }\n\n  &__wrapper {\n    width: 100%;\n    height: 100%;\n  }\n\n  &__left {\n    display: flex;\n    width: 140px;\n    aspect-ratio: 1/1;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 100px;\n    flex-shrink: 0;\n    border-radius: 9999px;\n    overflow: hidden;\n    border: 1px solid var(--light-grey);\n\n    &--avatar {\n      width: 100%;\n      height: 100%;\n      flex-shrink: 0;\n      align-self: stretch;\n      object-fit: cover;\n    }\n  }\n\n  &__right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 32px;\n    flex: 1 0 0;\n    align-self: stretch;\n    border-left: 1px solid var(--accent-color-medium);\n    &--info {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      align-self: stretch;\n      &--title {\n        display: flex;\n        padding: 0px 0px 8px 20px;\n        flex-direction: column;\n        align-items: flex-start;\n        align-self: stretch;\n        border-bottom: 1px solid var(--accent-color-medium, #4a6fa5);\n        &--name {\n          color: var(--accent-color);\n          font-size: 16px;\n          font-weight: 700;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 1 !important;\n          overflow: hidden !important;\n          text-overflow: ellipsis;\n        }\n        &--institution {\n          color: var(--text-1);\n          font-size: 14px;\n          font-weight: 700;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 1 !important;\n          overflow: hidden !important;\n          text-overflow: ellipsis;\n        }\n      }\n\n      &--stat {\n        display: flex;\n        padding: 8px 0px 0px 20px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 4px;\n        align-self: stretch;\n        &--position {\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 1 !important;\n          overflow: hidden !important;\n          text-overflow: ellipsis;\n          align-self: stretch;\n          color: var(--dark-grey);\n          font-size: 12px;\n        }\n        &--statistics {\n          display: flex;\n          align-items: center;\n          gap: 20px;\n          &--item {\n            display: flex;\n            gap: 4px;\n\n            svg {\n              width: 14px;\n              height: 14px;\n              path {\n                stroke: var(--accent-color);\n              }\n              line {\n                stroke: var(--accent-color);\n              }\n            }\n\n            p {\n              color: var(--text-1);\n              font-size: 12px;\n\n              span {\n                font-weight: 700;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &--keywords {\n      padding-left: 20px;\n      overflow: hidden;\n      position: relative;\n      width: 100%;\n      height: 32px;\n\n      &__wrapper {\n        position: absolute;\n        display: flex;\n        align-items: flex-start;\n        gap: 8px;\n        align-self: stretch;\n      }\n\n      &--item {\n        display: flex;\n        padding: 8px;\n        align-items: center;\n        gap: 8px;\n        border-radius: 8px;\n        background: var(--accent-color-medium);\n        color: var(--accent-color-light);\n        font-size: 12px;\n        font-weight: 400;\n        white-space: nowrap;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-faculty-card": `HomeFacultyCard_home-faculty-card__uKhPU`,
	"home-faculty-card__right--info--title--name": `HomeFacultyCard_home-faculty-card__right--info--title--name__xNwEy`,
	"home-faculty-card__wrapper": `HomeFacultyCard_home-faculty-card__wrapper__lM0N1`,
	"home-faculty-card__left": `HomeFacultyCard_home-faculty-card__left__hyc5A`,
	"home-faculty-card__left--avatar": `HomeFacultyCard_home-faculty-card__left--avatar__v3BDs`,
	"home-faculty-card__right": `HomeFacultyCard_home-faculty-card__right__dnbO2`,
	"home-faculty-card__right--info": `HomeFacultyCard_home-faculty-card__right--info__I8Ybj`,
	"home-faculty-card__right--info--title": `HomeFacultyCard_home-faculty-card__right--info--title__Auifa`,
	"home-faculty-card__right--info--title--institution": `HomeFacultyCard_home-faculty-card__right--info--title--institution__UrBrR`,
	"home-faculty-card__right--info--stat": `HomeFacultyCard_home-faculty-card__right--info--stat__J0neE`,
	"home-faculty-card__right--info--stat--position": `HomeFacultyCard_home-faculty-card__right--info--stat--position__H+Sq6`,
	"home-faculty-card__right--info--stat--statistics": `HomeFacultyCard_home-faculty-card__right--info--stat--statistics__ZV5XT`,
	"home-faculty-card__right--info--stat--statistics--item": `HomeFacultyCard_home-faculty-card__right--info--stat--statistics--item__ZxcUF`,
	"home-faculty-card__right--keywords": `HomeFacultyCard_home-faculty-card__right--keywords__Bfs14`,
	"home-faculty-card__right--keywords__wrapper": `HomeFacultyCard_home-faculty-card__right--keywords__wrapper__bH3Sr`,
	"home-faculty-card__right--keywords--item": `HomeFacultyCard_home-faculty-card__right--keywords--item__MZOqj`
};
export default ___CSS_LOADER_EXPORT___;
